module.exports = {
	init: function () {
        jQuery(document).on('gform_post_render', function(event, form_id, current_page){
            jQuery('.ginput_container').each(function(){
                jQuery(this).find(':input').each(function(){
                    var formInput = jQuery(this);
                    if(formInput.attr('aria-invalid')){
                        formInput.attr('aria-required', 'true');
                    }
                });
            });
        });
	},
};
